import {Component, Input} from '@angular/core';
import {LoaderService} from "../../services/loader.service";

@Component({
  selector: 'app-loader',
  standalone: false,
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

  constructor(public loaderService: LoaderService) {
  }

  @Input() type: any;

  show() {
    this.loaderService.buildLoader();
  }

  hide(miliseconds?: number) {
    if (miliseconds) {
      setTimeout(() => {
        this.loaderService.destroyLoader();
      }, miliseconds);
    } else {
      setTimeout(() => {
        this.loaderService.destroyLoader();
      }, 600);
    }
  }
}
